<template>
    <div class="contenedor_modal_completo">
        <div class="contenedor_modal_completo_cabecera">
            <button type="button" class="btn btn-sm btn-outline-danger" v-shortkey="['esc']" @shortkey="cerrar"
                @click="cerrar">
                Cerrar
            </button>
        </div>
        <div class="contenedor_modal_completo_contenido">
            <b-container>
                <b-row>
                    <div class="col-sm-12 mt-3">
                        <h3>
                            Solicitud de anulación de factura
                        </h3>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <label for="" class="form-label">Método de búsqueda</label>
                        <select class="form-control form-control-sm" v-model="selector">
                            <option value="nit">NIT</option>
                            <!-- <option value="fecha">Fecha</option> -->
                        </select>
                    </div>
                    <div class="col-sm-6 mt-3">
                        <label for="" class="form-label">NIT</label>
                        <input type="text" id="campo_nit_solicitud_anulacion" autocomplete="off"
                            class="form-control form-control-sm" v-model="nit">
                    </div>
                    <!-- <div v-if="selector == 'fecha'" class="col-sm-3 mt-3">
                        <label for="" class="form-label">Fecha inicial</label>
                        <input type="date" class="form-control form-control-sm" v-model="fecha_inicial">
                    </div>
                    <div v-if="selector == 'fecha'" class="col-sm-3 mt-3">
                        <label for="" class="form-label">Fecha final</label>
                        <input type="date" class="form-control form-control-sm" v-model="fecha_final">
                    </div> -->
                    <div class="col-sm-2 mt-5">
                        <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                            @click="buscar_facturas">Buscar</button>
                    </div>
                    <div class="col-sm-12 mt-3">
                        <div class="marco_solicitudes_de_anulacion">

                            <table class="table table-sm table-striped table-bordered" style="font-size: 12px;">
                                <thead>
                                    <tr>
                                        <th style="width: 10%;text-align: center;">
                                            Fecha
                                        </th>
                                        <th style="width: 10%;text-align: center;">
                                            Serie
                                        </th>
                                        <th style="width: 10%;text-align: center;">
                                            Número
                                        </th>
                                        <th style="width: 10%;text-align: center;">
                                            NIT
                                        </th>
                                        <th style="width: 30%;">
                                            Nombre Cliente
                                        </th>
                                        <th style="width: 10%;text-align: center;">
                                            Total
                                        </th>
                                        <th style="width: 10%;text-align: center;">
                                            Estado
                                        </th>
                                        <th style=" width: 10%;text-align: center;">
                                            ...
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in registros" :key="index">
                                        <td style="text-align: center;">
                                            {{ item.fecha_movimiento }}
                                        </td>
                                        <td style="text-align: center;">
                                            {{ item.sat_serie }}
                                        </td>
                                        <td style="text-align: center;">
                                            {{ item.sat_numero }}
                                        </td>
                                        <td style="text-align: center;">
                                            {{ item.nit_cliente }}
                                        </td>
                                        <td>
                                            {{ item.nombre_cliente }}
                                        </td>
                                        <td style="text-align: center;">
                                            Q{{ (item.total_movimiento -
                                                item.total_descuentos__).toLocaleString(undefined, {
                                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                                }) }}
                                        </td>
                                        <td style="text-align: center;">
                                            {{ item.solicitud_anulacion_factura | estado_mod }}
                                        </td>

                                        <td style="text-align: center;">
                                            <button type="button" style="font-size: 9px;margin-right: 5px;"
                                                class="btn btn-sm btn-outline-dark"
                                                @click="abrir_modal_detalle_factura(item)"><i
                                                    class="fas fa-eye"></i></button>
                                            <button v-if="item.solicitud_anulacion_factura == 0" type="button"
                                                style="font-size: 9px;" class="btn btn-sm btn-outline-dark"
                                                @click="enviar_solicitud_de_anulacion(item)"><i
                                                    class="fas fa-ban"></i></button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </b-row>
            </b-container>
        </div>
        <DetalleFactura v-if="modal_detalle" :objeto="detalle" v-on:salir="cerrar_modal" />
    </div>
</template>

<script>
    import { texto, minix } from '@/components/functions/alertas';
    import moment from 'moment';
    import { mapActions, mapState } from 'vuex';
    import DetalleFactura from './ModalDetalleFactura.vue'

    export default {
        name: 'SolicitudAnulacion',
        computed: {
            ...mapState(['id_empresa_seleccionada', 'datos_usuario']),

        },
        components: {
            DetalleFactura
        },
        filters: {
            estado_mod: function (val) {
                return val == 1 ? 'Pendiente' : 'Activa'
            }
        },
        data() {
            return {
                selector: 'nit',
                nit: '',
                fecha_inicial: moment(Date.now()).format('YYYY-MM-DD'),
                fecha_final: moment(Date.now()).format('YYYY-MM-DD'),
                registros: [],
                detalle: {},
                modal_detalle: false
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            calcular_total(total, descuento) {

                if (descuento == 0) {
                    return total.toLocaleString(undefined, {
                        minimumFractionDigits: 2, maximumFractionDigits: 2
                    })
                } else {
                    return (total - (total - descuento)).toLocaleString(undefined, {
                        minimumFractionDigits: 2, maximumFractionDigits: 2
                    })
                }
            },
            async buscar_facturas() {
                if (this.nit == '') {
                    minix({ icon: 'info', mensaje: 'Indica el nit', tiempo: 3000 })
                    document.getElementById('campo_nit_solicitud_anulacion').focus()
                    return
                }
                let f = {
                    api: `movimientos-cabeceras/c/obtener-facturas-para-anular?empresa=${this.id_empresa_seleccionada}&sucursal=${this.datos_usuario.sucursal_asignada}&fecha_inicial=${this.fecha_inicial}&fecha_final=${this.fecha_final}&nit=${this.nit.trim()}&filtro=${this.selector}`
                }

                let r = await this.obtener_data(f)
                if (r.length == 0) {
                    minix({ icon: 'info', mensaje: 'No se encontraron registros', tiempo: 3000 })
                } else {
                    this.registros = r
                }
            },
            async enviar_solicitud_de_anulacion(obj) {

                texto({ titulo: "Indica el motivo de la anulación", input: 'textarea' }, async (i) => {

                    let f = {
                        api: `solicitudes-de-anulaciones/g/solicitud-de-anulacion`,
                        formulario: {
                            autorizacion: obj.sat_no_autorizacion,
                            serie: obj.sat_serie,
                            numero: obj.sat_numero,
                            nit: obj.nit_cliente,
                            fecha: obj.fecha_movimiento,
                            motivo: i,
                            empresa: this.id_empresa_seleccionada,
                            sucursal: this.datos_usuario.sucursal_asignada,
                            operador: this.datos_usuario.id,
                            total_movimiento: obj.total_movimiento,
                            nombre_cliente: obj.nombre_cliente
                        }
                    }

                    let r = await this.guardar_data(f)
                    await this.buscar_facturas()

                })
            },
            abrir_modal_detalle_factura(item) {
                this.detalle = item
                this.modal_detalle = true
            },
            cerrar_modal() {
                this.modal_detalle = false
            },
            ...mapActions(['obtener_data', 'guardar_data'])
        },
    }
</script>

<style>
    .marco_solicitudes_de_anulacion {
        width: 100%;
        height: calc(100vh - 220px);
        overflow: auto;
    }
</style>